/**
 * This is a helper function called by reducers to allow for special sorting, processing,
 * and storing of various config types (bools, images, etc) since configs are
 * "general purpose"
 * @param  {object} state  initial state
 * @param  {object} config config to process
 * @param  {array}  apps "values of app config types to process (ex. login, xis, all)"
 * @param  {bool}   storeValueOnly - in some cases (appConfig) we don't store full config
 * objects in state and rather, just store the config.value.
 * @return {[type]}        modified state
 */
export const processConfig = (state, config, apps, storeValueOnly = false) => {
  let newState = { ...state }
  if (
    apps.some(app => {
      return (
        app === '*' ||
        (app === null && config.app === null) ||
        (app != null &&
          config.app != null &&
          config.app.toLowerCase() === app.toLowerCase())
      )
    })
  ) {
    // change string bools to real bools
    if (!storeValueOnly) {
      // I hate this and we should fix it someday but currently appConfig which
      // is what uses storeValueOnly doesn't do the boolean conversion so without
      // this if, we have change everywhere the app uses a t/f appConfig value to be
      // boolean and thats a bigger project than I can do right now.
      config = convertTFToBool(config)
    }

    // store images in image array
    newState = processImageConfigs(newState, config)
    if (config.name == 'headerStyleOverride' && config.section == 'read_only') {
      // this is a special config that doesn't need to be stored but we do need to respond to it.
      // currently we only support backgroundColor
      if (config?.value?.backgroundColor) {
        document.querySelector(':root').style.setProperty(
          '--header-color', // override ema primary brand which is used on header and other important elements
          config.value.backgroundColor
        )
      }
      return newState // skip the remainder of processing this config
    }

    // handle remainder
    if (config.section !== 'image') {
      newState[config.name] = storeValueOnly ? config.value : config
    }
  }
  return newState
}

/**
 * Similar to the processConfig function but specific to deletion... because images
 * are stored separately they need to be deleted separately.
 * @param  {[type]} state  [description]
 * @param  {[type]} config [description]
 * @param  {[type]} apps   [description]
 * @return {[type]}        [description]
 */
export const processConfigDelete = (state, config, apps) => {
  const newState = { ...state }
  if (
    config.section === 'image' &&
    apps.some(app => {
      return (
        app === '*' ||
        (app === null && config.app === null) ||
        (app != null &&
          config.app != null &&
          config.app.toLowerCase() === app.toLowerCase())
      )
    })
  ) {
    const idx = newState.images.findIndex(
      image => image.config_id == config.config_id
    )
    if (idx !== -1) {
      // if we found it delete it from the images array
      newState.images.splice(idx, 1)
    }
  } else {
    delete newState[config.name]
  }
  return newState
}

const processImageConfigs = (state, config) => {
  if (config.section === 'image') {
    const images = state.images != null ? [...state.images] : []
    let found = false
    images.forEach((img, idx) => {
      if (
        // if the configs have the same id
        (img.config_id === config.config_id) ||
        // or if the configs have the same "key" (name, section, app)
        // note: this only happens in dev when we switch databases
        (
          img.name === config.name &&
          img.section === config.section &&
          img.app === config.app
        )
      ) {
        // then update the existing image index with the details of the new config
        images[idx] = config
        found = true
      }
    })
    if (!found) {
      images.push(config)
    }
    state.images = [...images]
  }

  return state
}

/**
 * configs in the database are often stored with t/f values representing booleans.
 * This is a helper function to convert those values to actual booleans to avoid
 * checking and worrying about cases throught the rest of the app.
 * @param  {[type]} config [description]
 * @return {[type]}        [description]
 */
const convertTFToBool = config => {
  if (
    (typeof config.value === 'string' || config.value instanceof String) &&
    config.value.toLowerCase() === 't'
  ) {
    config.value = true
  } else if (
    (typeof config.value === 'string' || config.value instanceof String) &&
    config.value.toLowerCase() === 'f'
  ) {
    config.value = false
  }
  return config
}
